module.exports = __webpack_public_path__ + "static/img/4-1.bbb675b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/4-1.jpg
// module id = 90/D
// module chunks = 25